import { z } from "zod";
import { getOnesaasApiUrlAuth } from "../../../config/config";
import { authStrategy } from "./../../../auth/index";

const mMHiveAccountSchema = z
  .object({
    user_id: z.string(),
    email: z.string(),
    roles: z.array(z.string()),
    projects: z.array(
      z.object({
        project_id: z.string(),
        account_id: z.string(),
        name: z.string(),
      })
    ),
    current_project: z.string(),
  })
  .deepPartial();

export type MmHiveAccountSchema = z.infer<typeof mMHiveAccountSchema>;

export const getHiveAccount = async (): Promise<MmHiveAccountSchema> => {
  try {
    const authUrl = getOnesaasApiUrlAuth();
    const token = authStrategy.getToken();

    if (!authUrl) {
      throw new Error("authUrl not found");
    }

    const whoAmIResponse = await fetch(`${authUrl}/whoami`, {
      method: "GET",
      headers: { Authorization: `Bearer ${token?.token}` },
    });
    const whoAmIData = await whoAmIResponse.json();

    return mMHiveAccountSchema.parse(whoAmIData);
  } catch (e) {
    console.error("pingHiveForAccount_failed: ", e);
    return {};
  }
};
